export default [{
        name: 'dashboard',
        title: '儀表板',
        icon: 'tachometer-alt-fast',
        group: '1',
        description: '總覽',
    },
    {
        name: 'products',
        title: '所有項目',
        icon: 'grip-horizontal',
        group: '1',
        description: '新增、編輯項目內容以及時段價格設定。',
    },
    {
        name: 'orders',
        title: '訂單查詢',
        icon: 'clipboard-list',
        group: '1',
        description: '瀏覽你的所有訂單以及付款狀態，或是更改訂單狀態。',
    },
    {
        name: 'analytics',
        title: '數據分析',
        icon: 'analytics',
        group: '1'
    },
    {
        name: 'staff',
        title: '項目人員',
        icon: 'users-class',
        group: '1',
        description: '管理活動或課程相關人員（來賓、講師⋯⋯等）。',
    },
    {
        name: 'coupon',
        title: '優惠券',
        icon: 'ticket-alt',
        group: '1',
        description: '設定活動或課程優惠券，讓客戶輸入代碼享有折扣。',
    },
    {
        name: 'prepaid',
        title: '預付方案',
        icon: 'piggy-bank',
        group: '1',
        description: '',
    },
    {
        name: 'member',
        title: '客戶管理',
        icon: 'address-book',
        group: '2',
        description: '瀏覽在您商店預訂過的客戶',
    },
    {
        name: 'admin',
        title: '商店管理帳號',
        icon: 'user-lock',
        group: '2',
        description: '新增附屬帳號協助管理你的商店。',
    },
    {
        name: 'settings',
        title: '商店設定',
        icon: 'cog',
        group: '3',
        description: '設定商店名稱、介紹文字、Logo 圖⋯⋯等；查看方案訂閱刷卡紀錄、申請金流開通、設定 LINE Bot。',
    },
    // {
    //   name: 'report',
    //   title: '問題回報',
    //   icon: 'exclamation-triangle',
    //     group: '3'
    // },
]
